import { render, staticRenderFns } from "./LtiDisclamer.vue?vue&type=template&id=6355cb88&scoped=true&lang=pug&"
import script from "./LtiDisclamer.vue?vue&type=script&lang=ts&"
export * from "./LtiDisclamer.vue?vue&type=script&lang=ts&"
import style0 from "./LtiDisclamer.vue?vue&type=style&index=0&id=6355cb88&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6355cb88",
  null
  
)

export default component.exports